import React, { useState } from "react";
import { Box, Typography, TextField, Alert } from "@mui/material";
import { ContainedButton } from "../buttonCompo/Buttons";

const SupportForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  // Validation Function
  const validateForm = () => {
    let newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }
    if (!formData.message.trim()) newErrors.message = "Message cannot be empty";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return; // Stop submission if validation fails

    console.log(formData, "Form Data");

    // Simulate API request success
    setTimeout(() => {
      setSuccessMessage("Your support request has been submitted successfully!");
      setFormData({ name: "", email: "", message: "" });
      setErrors({});
    }, 1000);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${process.env.PUBLIC_URL}/icons/login/loginBg.svg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          width: "300px",
          padding: "20px",
        }}
      >
        <img src="/icons/LogoBlack.svg" alt="Logo" />
        <Typography
          variant="body2"
          color="#1560BD"
          sx={{
            fontSize: "22px",
            fontWeight: 700,
            mb: 2,
          }}
        >
          Support
        </Typography>

        {successMessage && (
          <Alert severity="success" sx={{ mb: 2, width: "100%" }}>
            {successMessage}
          </Alert>
        )}

        {/* Name Input */}
        <Typography variant="subtitle1" fontWeight={700} align="left" sx={{ width: "100%" }}>
          Name
        </Typography>
        <TextField
          variant="outlined"
          placeholder="Enter your name"
          name="name"
          autoComplete="off"
          value={formData.name}
          onChange={handleChange}
          fullWidth
          required
          error={!!errors.name}
          helperText={errors.name}
          sx={{ mb: 2 }}
        />

        {/* Email Input */}
        <Typography variant="subtitle1" fontWeight={700} align="left" sx={{ width: "100%" }}>
          Email
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          autoComplete="off"
          type="email"
          name="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={handleChange}
          required
          error={!!errors.email}
          helperText={errors.email}
          sx={{ mb: 2 }}
        />

        {/* Message Input */}
        <Typography variant="subtitle1" fontWeight={700} align="left" sx={{ width: "100%" }}>
          Message
        </Typography>
        <TextField
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          autoComplete="off"
          name="message"
          placeholder="Your Message"
          value={formData.message}
          onChange={handleChange}
          required
          error={!!errors.message}
          helperText={errors.message}
          sx={{ mb: 2 }}
        />

        {/* Submit Button */}
        <Box>
          <ContainedButton label="Submit" textColor="white" onClick={handleSubmit} />
        </Box>
      </Box>

      {/* Terms & Privacy Links */}
      <div className="policy-links">
        <a href="/terms-condition" target="_blank" rel="noopener noreferrer">
          Terms and Conditions
        </a>
        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
      </div>
    </Box>
  );
};

export default SupportForm;
